import * as React from 'react';
import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-10 w-full rounded-control border border-[color:var(--kz-color-border-default)] ' +
          'bg-transparent px-3 py-2 text-sm placeholder:text-[color:var(--kz-color-ink-muted)] ' +
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--kz-color-border-focus)] ' +
          'disabled:cursor-not-allowed disabled:opacity-50 file:border-0 file:bg-transparent file:text-sm file:font-medium',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
